// src/components/LoadingPage.tsx
import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import loadingGif from '../assets/gifs/nuclear-loading.gif';

const LoadingPage: React.FC = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                height: '100vh',
                width: '100%',
                bgcolor: theme.palette.background.default,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2,
            }}
        >
            <Box
                component="img"
                src={loadingGif}
                alt="Loading nuclear reactor"
                sx={{
                    width: { xs: '40px', sm: '80px' },
                    height: 'auto',
                    mb: 2,
                }}
            />
            <Typography variant="subtitle2" color="textSecondary">
                Loading…
            </Typography>
        </Box>
    );
};

export default LoadingPage;
